import React from 'react'
import resouce from './resource.module.css'
import Resource1 from './Resource1'
import ResourceBoxs from './ResourceBoxs'
import Nav from '../Nav/Nav'
import Footer from '../Footer/Footer'
import useStore from '../../../Store'
export const Resource = () => {
    const direction = useStore((state) => state.direction);
    return (
        <div style={{ direction }}>
            <Nav />
            <div className={resouce.Resource_container}>
                <Resource1 />
                <ResourceBoxs />
            </div>
            <Footer />
        </div>

    )
}
